import { Grid, Typography } from '@mui/material';
import React from 'react';
import { IMaterialDetailsDialogProps } from '../../interfaces';
import { MaterialNoteDialog } from '../MaterialNoteDialog';
import './index.scss';
import { NoDetailNotice } from './NoDetailNotice';

export const Notes: React.SFC<IMaterialDetailsDialogProps> = ({
    material,
    onReloadMaterial,
    ...props
}: IMaterialDetailsDialogProps) => {

    const handleNoteAdded = () => {
        if (onReloadMaterial && material?.materialId)
            onReloadMaterial(material.materialId)
    }

    return (
        <Grid container>
            <Grid item xs={6} paddingRight={1}>
                <Typography className="material-property-text">
                    <strong>Notes</strong>
                </Typography>
                <ul>
                    {material.notes?.length === 0 ? <NoDetailNotice label="notes" /> : material.notes?.map((mn, i) => {
                        return (
                            <li key={i}>{mn.note}</li>
                        )
                    })}
                </ul>

                <br />

                {onReloadMaterial &&
                    <MaterialNoteDialog
                        materialId={material.materialId}
                        onNoteAdded={handleNoteAdded}
                    />
                }
            </Grid>
            <Grid item xs={6}>

                <Typography className="material-property-text">
                    <strong>Usage Restrictions</strong>
                </Typography>
                {material.usageRestrictions ?? <NoDetailNotice label="usage restrictions" />}

                <Typography className="material-property-text">
                    <strong>Origin of Valuation</strong>
                </Typography>
                {material.valuationOrigin ?? <NoDetailNotice label="details about the origin of the valuation" />}
            </Grid>

        </Grid>
    );
}